// Inject error messages for yafov validations
// Set is_message to true if this is just a message and you
// don't want to add red error styling to the field
export function buildErrorMessage(error, is_message) {
  if (error.name == '') return false;
  var $msg = $('<label>', { for: error.field.id }),
    icon = chooseIcon(),
    $field = $(error.field);
  is_message = typeof is_message != 'undefined' ? is_message : false; // is_message defauts to false

  error.type && error.type == 'ajax'
    ? $msg.addClass('ajax_message')
    : $msg.addClass('error_message c-red fs-12 pv1');

  function chooseIcon() {
    if (error.type && error.type == 'ajax') {
      return '<span class="icon icon_ajax"></span> ';
    }
    return '<span class="icon icon_warning"></span>';
  }

  switch (error.name) {
    case 'required':
      $msg.html(ICMIB.t('field_required'));
      break;
    case 'email':
      $msg.html(ICMIB.t('must_be_valid_email'));
      break;
    case 'no_email':
      $msg.html(ICMIB.t('cannot_be_email'));
      break;
    case 'url':
      $msg.html(ICMIB.t('must_be_valid_url'));
      break;
    case 'tel':
      $msg.html('Must be a valid phone number');
      break;
    case 'unique_email':
      $msg.html(ICMIB.t('email_taken'));
      break;
    case 'unique_subdomain':
      $msg.html(ICMIB.t('subdomain_taken'));
      break;
    case 'checking_email':
      $msg.html(ICMIB.t('checking_email'));
      break;
    case 'checking_subdomain':
      $msg.html(ICMIB.t('checking_subdomain'));
      break;
    case 'match_password':
      $msg.html(ICMIB.t('match_password'));
      break;
    case 'requiredSingleSelect':
      $msg.html(ICMIB.t('must_choose_one'));
      break;
    case 'requiredMultipleChoice':
      $msg.html(ICMIB.t('must_choose_at_least_one'));
      break;
    case 'requiredMatrix':
      $msg.html(ICMIB.t('must_make_one_entry_per_row'));
      break;
    default:
      $msg.html(ICMIB.t('general_validation_error'));
      break;
  }
  $msg.prepend(icon);
  // Remove previous error message
  $field
    .closest('.field')
    .find('.error_message, .ajax_message')
    .remove();
  if (!is_message) {
    // Add error styling unless this is just a message
    $field
      .closest('.field')
      .addClass('field_with_errors')
      .removeClass('valid_field');
  }
  // Insert error message
  $field.closest('.field').append($msg);
}

// Hide error messages for yafov validations
export function removeErrorMessage(error) {
  // Removed this field for survey validations, may mess up registrations
  //if ($(error.field).is(":checkbox")) return true;
  var $field = $(error.field);
  $field.closest('.field_with_errors').removeClass('field_with_errors');
  $field.closest('.field').addClass('valid_field');
  $field
    .closest('.field')
    .find('.error_message, .ajax_message')
    .remove();
}

/*
 *  Custom validation method for a 'required' group of checkboxes or radios
 *  This will require that one of the options be checked
 */
// This is the validator method, it take a group of elements and compares them
function requiredChooseOneOrManyValidator(value, elements, callback) {
  // Presume invalid
  var valid = false;

  // If at least one of the group is checked, then we're valid
  elements.each(function() {
    if (this.type == 'checkbox' || this.type == 'radio' || this.type == 'slider') {
      valid = this.checked;
    } else {
      valid = this.value != '';
    }

    if (valid) return false;
  });

  callback(valid);
}
// This method collects all the inputs in the group
function requiredChooseOneOrManyGetGroup(el) {
  var wrapper = el.closest('.field'),
    elements;
  elements = wrapper.find('input, select');
  return elements;
}

/*
 *  Initialize user registration validation
 */
export function initUserRegistrationValidation() {
  // validation
  var user_validator = $('#user_new, #new_user').yafov();
  // field is invalid
  user_validator.bind('invalidfound', function(e, error) {
    ICMIB.buildErrorMessage(error);
  });
  // field is valid
  user_validator.bind('validfound', function(e, error) {
    $('#sign_up_submit').prop('disabled', false);
    ICMIB.removeErrorMessage(error);
  });
  // Submit for if everything is valid
  user_validator.bind('formvalid', function() {
    this.submit();
  });

  // Password matching
  var matchPasswords = function(e) {
    if ($('#user_password_confirmation').val() == '') return true;
    var result = {
      field: $('#user_password_confirmation'),
      isGroup: false,
      name: 'match_password',
    };
    if ($('#reg_password').val() == $('#user_password_confirmation').val()) {
      result.isValid = true;
      $('#user_password_confirmation').trigger('validfound', result);
    } else {
      result.isValid = false;
      if (e.type == 'submit') e.preventDefault();
      $('#user_password_confirmation').trigger('invalidfound', result);
    }
  };
  $('#reg_password, #user_password_confirmation').blur(matchPasswords);
  $('#user_new').submit(matchPasswords);
}

let BACKOFF = 50;

function addYafovMethods() {
  if (!$.yafov) {
    return setTimeout(() => {
      BACKOFF = BACKOFF * 2;
      addYafovMethods();
    }, BACKOFF);
  }
  // CUstom validation method to ensure uniqueness of subdomain
  $.yafov.addMethod('.unique_subdomain', '.unique_subdomain', function(
    value,
    element,
    cb
  ) {
    ICMIB.unique_subdomain_xhr.abort(); // Cancel previous requests, esp since it sometimes fires twice
    var $field = $(element)
      .closest('.field')
      .removeClass('field_with_errors valid_field');
    ICMIB.buildErrorMessage(
      {
        field: element,
        name: 'checking_subdomain',
        type: 'ajax',
      },
      true
    );

    ICMIB.unique_subdomain_xhr = $.ajax({
      url: $(element).data('unique-subdomain-url'),
      data: 'subdomain=' + encodeURIComponent(value),
      complete: function() {
        $field.removeClass('working');
      },
      success: function(response) {
        // call the callback function, pass to it that is the field is valid or no
        if (response.success) {
          cb(true);
        } else {
          cb(false);
        }
      },
    });
  });

  // Custom validation method to disallow emails as names for users
  $.yafov.addMethod('.no_email', 'no_email', function(value, element, cb) {
    cb(!value.match(/@/));
  });

  $.yafov.addGroupMethod(
    '.required.single_select input, .required.single_select select', // selector
    'requiredSingleSelect', // event name
    requiredChooseOneOrManyValidator,
    requiredChooseOneOrManyGetGroup
  );
  $.yafov.addGroupMethod(
    '.required.multiple_select input', // selector
    'requiredMultipleChoice', // event name
    requiredChooseOneOrManyValidator,
    requiredChooseOneOrManyGetGroup
  );

  /*
 * Required matrix validations
 * Enforces one entry per row
 */
  $.yafov.addGroupMethod(
    '.required.matrix input, .required.matrix select', // selector
    'requiredMatrix', // event name

    // validate!
    function requiredMatrixValidator(value, elements, callback) {
      // Presume valid
      var valid = true;

      // If each row has at least one entry, remain valid
      elements.each(function() {
        var $row = $(this),
          row_valid = false; // Presume this row is invalid

        $row.find('input, textarea, select').each(function() {
          // If this is the Other row, skip it
          if ($row.hasClass('other_row')) return false;

          // If any of the inputs in this row has a value, this row is valid
          if (this.type == 'checkbox' || this.type ==  'radio' || this.type == 'slider') {
            row_valid = this.checked;
          } else {
            row_valid = $(this).val() != '';
          }
          // If we found a value, go ahead and exit this row
          if (row_valid) return false;
        });

        // If this row remained invalid, the whole question is invalid
        if (!row_valid) {
          valid = false;
          return false;
        }
      });

      callback(valid);
    },

    // Collect each row
    function requiredMatrixGetGroup(el) {
      var wrapper = el.closest('.field'),
        elements;
      elements = wrapper.find('tbody tr');
      // Ignore 'Other' rows for now
      return elements.not('.other_row');
    }
  );
}
addYafovMethods();
